// Sales reducer helper functions and data
import moment from "moment";
import { SalesState } from "./sales.types";
import { getInitialPaginationData } from "util/pagination";
import { PaymentMethod } from "types/orders.types";
import { buildInitialShoppingCart } from "util/testUtils/builders/sales/shoppingCart.builder";
import { Channel } from "types/sales/channel.types";
import { Vendor } from "types/sales/vendor.types";

export const findPaymentMethodById = (
  state: SalesState,
  paymentMethodId: number
): PaymentMethod | undefined | {} => {
  const { paymentMethods } = state;
  const paymentMethod = paymentMethods
    ? paymentMethods[paymentMethodId]
    : undefined;
  return { ...paymentMethod };
};

export const findChannelById = (
  state: SalesState,
  channelId: number | undefined
): Channel | undefined => {
  if (!state.channels || typeof channelId === "undefined") {
    return;
  }
  const channel = Object.values(state.channels).find(
    channel => channel.id === channelId
  );
  if (!channel) {
    return undefined;
  }
  return channel;
};

export const findVendorById = (
  state: SalesState,
  vendorId: number | undefined
): Vendor | undefined => {
  if (!state.vendors || typeof vendorId === "undefined") {
    return;
  }
  const vendor = Object.values(state.vendors).find(
    vendor => vendor.id === vendorId
  );
  if (!vendor) {
    return undefined;
  }
  return vendor;
};

export const stateInitOrder: Partial<SalesState> = {
  selectedStoreId: undefined,
  selectedCategoryId: undefined,
  shoppingCart: buildInitialShoppingCart(),
  recommendedProduct: undefined,
  selectedCartItemId: undefined,
  selectedProductId: undefined,
  selectedPaymentMethodId: undefined
};

export const stateAfterOrder: Partial<SalesState> = {
  stores: getInitialPaginationData(),
  selectedStoreId: undefined,
  selectedCategoryId: undefined,
  shoppingCart: buildInitialShoppingCart(),
  recommendedProduct: undefined,
  selectedCartItemId: undefined,
  selectedProductId: undefined,
  selectedPaymentMethodId: undefined
};

export const salesStateLogout: SalesState = {
  account: undefined,
  channels: undefined,
  selectedChannel: findChannelById,
  vendors: undefined,
  salesProcess: undefined,
  selectedChannelId: undefined,
  selectedVendorId: undefined,
  selectedVendor: findVendorById,
  selectedDateRange: [moment().subtract(1, "week"), moment()],
  stores: getInitialPaginationData(),
  searchStores: getInitialPaginationData(),
  selectedStoreId: undefined,
  selectedCategoryId: undefined,
  selectedProductId: undefined,
  shoppingCart: buildInitialShoppingCart(),
  recommendedProduct: undefined,
  paymentMethods: undefined,
  selectedPaymentMethodId: undefined,
  selectedPaymentMethod: findPaymentMethodById,
  selectedCartItemId: undefined,
  lastOrder: undefined,
  lastOrderTickets: undefined,
  paymentInscriptions: undefined
};
